/* eslint-disable no-underscore-dangle */
import { createImgSrc } from '@js/utils/images';
import { displayNsfwOverlay } from '@js/nsfw';
import { rootPath } from '@js/utils/url';

const isSoldOut = (product) => {
  return product.stock.toLowerCase() === 'out of stock' || product.variants.every(({ price }) => Number(price) === 0);
};

export const product = (product, { html, sendEvent }) => {
  const soldOut = isSoldOut(product);
  const locale = JSON.parse(document.getElementById('getLocale').textContent);

  const renderSoldOut = soldOut ?
    html`
        <div class="product-overlay sold-out w-backdrop-opacity-10 tw-bg-white/40">
          <span class="sold-out__content tw--rotate-12 tw-pb-24 tw-text-xl tw-font-bold tw-uppercase tw-tracking-wider">
            ${locale.products.sold_out}
          </span>
        </div>
      ` :
    html``;

  const renderNsfw = displayNsfwOverlay(product.shopify_product_data) ?
    html`
        <nsfw-overlay class="product-overlay nsfw">
          <div class="tw-flex tw-flex-col tw-items-center tw-pb-24 tw-font-semibold">
            <div class="tw-text-5xl tw-tracking-wider">${locale.products.nsfw.title}</div>

            <button class="tw-text-sm tw-font-bold tw-uppercase" type="button">${locale.products.nsfw.text}</button>
          </div>
        </nsfw-overlay>
      ` :
    html``;

  return html`
    <div
      class="product__item${soldOut ? ' product__item--sold-out' : ''} hover:tw-shadow-lg"
      data-render="search-product"
      data-shopify-id="${product.shopify_id}"
    >
      <a
        id="product-${product.shopify_id}"
        class="product-link"
        href="${rootPath()}products/${product.shopify_handle}?oid=${product.objectID}&qid=${product.__queryID}"
        aria-label="${product.name_en}"
        ${sendEvent('click', product, 'Product Viewed')}
      >
        ${renderNsfw} ${renderSoldOut}

        <div class="tw-flex tw-h-full tw-flex-col tw-items-center tw-justify-between">
          <img
            class="tw-h-60 tw-object-contain"
            loading="lazy"
            src=${createImgSrc(product.image, '480x480')}
            srcset="
              ${createImgSrc(product.image, '600x600')} 1.5x,
              ${createImgSrc(product.image, '1024x1024')} 2.5x,
              ${createImgSrc(product.image, '1024x1024')} 3x
            "
            alt=${encodeURIComponent(product.name_en)}
          />

          <div class="product-information tw-flex tw-w-full tw-flex-col sm:tw-p-2 sm:tw-pt-0">
            <h3 class="title tw-mx-0 tw-my-4 tw-text-base tw-font-normal tw-text-black">${product.name_en}</h3>

            <div class="product__labels-wrapper tw-w-full" data-component="ProductVariants">
              <div class="product-label product-label--placeholder"></div>
            </div>
          </div>
        </div>
      </a>
    </div>
  `;
};

export const checkbox = (filter) => {
  // For whatever reason the html render breaks the checkbox
  return `
    <label class="filter__checkbox">
      ${filter.label}
      <input type="checkbox" value="${filter.isRefined ? 'on' : 'off'}" ${filter.isRefined ? ' checked' : ''} />
      <span class="checkmark"></span>
    </label>
  `;
};

export const hierarchicalMenuItem = (data, { html }) => {
  return html`
    <a class="${data.cssClasses.link}" href="${data.url}">
      <span class="${data.cssClasses.label}">${data.label}</span>
      <span class="${data.cssClasses.count}"> ${data.count.toLocaleString()} </span>
    </a>
  `;
};

export default {
  product,
  checkbox,
  hierarchicalMenuItem,
};
